// extracted by mini-css-extract-plugin
export var author = "front-post-module--author--98fb7";
export var category = "front-post-module--category--dc0f3";
export var excerpt = "front-post-module--excerpt--3278d";
export var headline = "front-post-module--headline--020f7";
export var headlinePost = "front-post-module--headline-post--a4c74";
export var paragraph = "front-post-module--paragraph--ef205";
export var post = "front-post-module--post--dfd5f";